import { providePaymentMethods } from '@/src/experiences/card-payments/providePaymentMethods'
import * as MesaLib from '@acre-rewards/lib'

export const withPaymentMethodsForCardManagement = providePaymentMethods({
  products: [MesaLib.Plaid.Products.enum.Auth],
  shouldLinkToHighnote: true,
  shouldImportTransactions: false,
})
